import Pagination from 'react-bootstrap/Pagination';
import styles from './styles.module.css';
import { useEffect } from 'react';


function CoursesPagination(props: any) {
    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    }, [props.page]);

    return (
        <div className={styles.pagination}>
            <Pagination>
                {props.previous !== null && (
                    <Pagination.Prev
                        onClick={() =>
                            props.setPage((oldPage: number) => oldPage - 1)
                        }
                    />
                )}

                {new Array(props.pagesNum).fill(0).map((_, index) =>
                    index + 1 > props.page - 3 && index + 1 < props.page + 3 ? (
                        <Pagination.Item
                            key={`p-${index}`}
                            disabled={props.page === index + 1}
                            active={props.page === index + 1}
                            onClick={() => props.setPage(index + 1)}
                        >
                            {index + 1}
                        </Pagination.Item>
                    ) : null
                )}

                {props.next !== null && (
                    <Pagination.Next
                        onClick={() =>
                            props.setPage((oldPage: number) => oldPage + 1)
                        }
                    />
                )}
            </Pagination>
        </div>
    );
}

export default CoursesPagination;
